<ngx-ui-loader></ngx-ui-loader>
<div id="employee" class="page-layout simple tabbed">
  <employee-header [complexId]="complexId" (searchString)="sendSearchFilter($event)"></employee-header>
  <div class="page-wrapper">
    <complex-selector (complexConn)="sendComplexId($event)"></complex-selector>
    <employee-table [complexId]="complexId" [searchString]="search"></employee-table>
  </div>
</div>
